import React from "react"
import { injectIntl } from "react-intl"



type OwnProps = {
    calculatedUnitPrice : number
    unitPrice : number
}

const DiscountedPriceBadge = (props: OwnProps) => { 
    
    return <span className={"mt-3 discountBadge badge badge-light"}>
        <s>{props.unitPrice}
        </s>  {props.calculatedUnitPrice}
    </span>
   
}


export default injectIntl(DiscountedPriceBadge)


// WEBPACK FOOTER //
// ./src/quote/DiscountedPriceBadge.tsx